import jwt_decode from "jwt-decode";

import {
  getCookie,
} from "./utility";

if (typeof window.getCookie != 'function') {
  window.getCookie = getCookie;
}

/*
 * Easy implementation using disqus cookie. Not reliable and not secure.
 */

var USER_DATA_STORAGE_KEY = "userData";
var userDataStorage = {
  setData: function (data) {
    var raw_data = data
    if (typeof data === "object") {
      raw_data = JSON.stringify(data);
    }
    localStorage.setItem(USER_DATA_STORAGE_KEY, raw_data);
  },
  getData: function () {
    return JSON.parse(localStorage.getItem(USER_DATA_STORAGE_KEY));
  },
  clearData: function () {
    localStorage.removeItem(USER_DATA_STORAGE_KEY);
  }
}

function fullData(resolve, reject) {
  fetch('/a0/fulldata')
    .then(response => response.json())
    .then(data => resolve(data));
}


function capabilitiesData(resolve, reject) {
  fetch('/a0/capabilities')
    .then(response => response.json())
    .then(data => resolve(data))
    .catch((error) => {
      console.error('Error:', error);
      // empty default in case of error
      resolve({
        capabilities: {}
      });
    });
}

function syncFullData(callback) {
  new Promise(fullData).then(
    data => {
      userDataStorage.setData(data);
      if (typeof callback === 'function') callback(data);
    });
}

function syncCapabilities(callback) {
  new Promise(capabilitiesData).then(
    data => {
      // userDataStorage.set isn't priority at the moment
      // because we are downloading capabilities on every pageview anyway
      // userDataStorage.set("capabilities", data);
      if (typeof callback === 'function') callback(data.capabilities);
    });
}

function getPayingStatus(capabilities) {
  var statusSfogliatore = false;
  var statusSubscriber = false;
  for (const [capability, enabled] of Object.entries(capabilities)) {
    if (capability.indexOf('sfogliatore') == 0 && enabled) statusSfogliatore = true;
    if (capability.indexOf('premium') == 0 && enabled) statusSubscriber = true;
  }
  if (statusSfogliatore) return 'Sfogliatore';
  if (statusSubscriber) return 'Subscriber';
}

function authSessionInit(resolve, reject) {

  var userInfo = {
    loginStatus: "Anonymous"
  }
  try {
    var jwtCookie = decodeURIComponent(getCookie(JWT_COOKIE));
    if (jwtCookie !== "") {
      var jwt_token = jwtCookie;
      userInfo = jwt_decode(jwt_token);
      if (userInfo.email_verified === true) {
        userInfo.loginStatus = "Registered";
      } else {
        userInfo.loginStatus = "Pending";
      }
      var userFullData = userDataStorage.getData();
      if (userFullData != null) {
        userInfo.primaryEdition = userFullData.user_metadata.primary_edition;
        userInfo.communityTerms = "community_terms_accepted_at" in userFullData.app_metadata;
        userInfo.newsletterUser = "newsletter_id" in userFullData.app_metadata;
        userInfo.capabilities = userFullData.capabilities || {};  // as default
        // but sync capabilities anyway
        syncCapabilities(capabilities => {
          userInfo.capabilities = capabilities;
          userInfo.paymentStatus = getPayingStatus(capabilities);
          resolve(userInfo);
        })
      } else {
        syncFullData();
        resolve(userInfo);
      }
    } else {
      resolve(userInfo);
    }
  } catch (e) {
    userInfo.error = e.message;
    reject(userInfo);
  }
}

const userInfoLoaded = new CustomEvent("UserInfoLoaded", { authSession: this });
window.authSession = new Promise(authSessionInit)
  .then(userInfo => { document.dispatchEvent(userInfoLoaded); return userInfo; });
window.userDataStorage = userDataStorage;
